import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@mui/material';
import { PrimaryButton, SecondaryButton } from '../../components/atoms/Button';
import CloseIcon from '@mui/icons-material/Close';

interface MaterialAdd {
  open: boolean;
  onClose: () => void;
  onSaved: () => void;
  setFormData: any;
  formData: any;
}

function AddMaterialModal({
  open,
  onClose,
  onSaved,
  setFormData,
  formData,
}: MaterialAdd) {
  const handleChange = (e: any) => {
    const { name, value } = e.target;

    let updatedValue: any = value;

    // ✅ Handle number fields (remove leading zeros)
    if (name === 'price') {
      updatedValue = value.replace(/^0+(?=\d)/, ''); // "012" → "12"
    }
    setFormData((prev: any) => ({ ...prev, [name]: updatedValue }));
  };
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="md"
      sx={{ borderRadius: 10, overflow: 'hidden' }}
      PaperProps={{
        sx: {
          borderRadius: 10,
          overflow: 'hidden',
        },
      }}
    >
      <Box
        sx={{
          border: '1px solid #7B1FA2',
          borderRadius: 10,
          overflow: 'hidden',
        }}
      >
        <DialogTitle
          sx={{
            fontSize: '22px',
            fontWeight: 'bold',
            color: '#fff',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            backgroundColor: '#181818',
            padding: '16px',
          }}
        >
          {formData?.id ? 'Edit Material' : 'Add Material'}
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <Divider />
        <DialogContent sx={{ backgroundColor: '#181818', padding: '24px' }}>
          <Grid container spacing={3}>
            <Grid item xs={6}>
              <Typography gutterBottom>Material Name</Typography>
              <TextField
                name="name"
                value={formData.name}
                onChange={handleChange}
                fullWidth
                required
                sx={{
                  backgroundColor: '#222',
                  borderRadius: '8px',
                  color: '#fff',
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <Typography gutterBottom>Unit</Typography>
              <Select
                name="unit"
                value={formData.unit}
                onChange={handleChange}
                fullWidth
                sx={{
                  backgroundColor: '#222',
                  borderRadius: '8px',
                  color: '#fff',
                }}
              >
                <MenuItem value="FT">Ft</MenuItem>
                <MenuItem value="KG">Kg</MenuItem>
                <MenuItem value="METER">Meter</MenuItem>
                <MenuItem value="PIECE">Piece</MenuItem>
              </Select>
            </Grid>
            <Grid item xs={6}>
              <Typography gutterBottom>Price</Typography>
              <TextField
                name="price"
                value={formData.price}
                onChange={handleChange}
                fullWidth
                sx={{
                  backgroundColor: '#222',
                  borderRadius: '8px',
                  color: '#fff',
                  '& input[type=number]': {
                    MozAppearance: 'textfield', // Firefox
                  },
                  '& input[type=number]::-webkit-outer-spin-button': {
                    WebkitAppearance: 'none',
                    margin: 0,
                  },
                  '& input[type=number]::-webkit-inner-spin-button': {
                    WebkitAppearance: 'none',
                    margin: 0,
                  },
                }}
                type="number"
                inputProps={{ min: 0 }}
              />
            </Grid>
            <Grid item xs={6}>
              <Typography gutterBottom>Status</Typography>
              <Select
                name="status"
                value={formData.status}
                onChange={handleChange}
                fullWidth
                sx={{
                  backgroundColor: '#222',
                  borderRadius: '8px',
                  color: '#fff',
                }}
              >
                <MenuItem value="ACTIVE">Active</MenuItem>
                <MenuItem value="INACTIVE">Inactive</MenuItem>
              </Select>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions sx={{ backgroundColor: '#181818', padding: '16px' }}>
          <DialogActions sx={{ backgroundColor: '#181818', padding: '16px' }}>
            <SecondaryButton title="Cancel" onClick={onClose} />
            <PrimaryButton title="Save" onClick={onSaved} />
          </DialogActions>
        </DialogActions>
      </Box>
    </Dialog>
  );
}

export default AddMaterialModal;
